// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__1fVbH","form":"styles_form__G4RcM"};